import { normalizeLanguageIconKey } from '../components/ui/IconRenderer';

const BY_ICON_KEY = Object.freeze({
  javascript: { bg: '#F7DF1E', text: '#323330', abbrev: 'JS' },
  python: { bg: '#3776AB', text: '#FFD343', abbrev: 'Py' },
  typescript: { bg: '#3178C6', text: '#FFFFFF', abbrev: 'TS' },
  java: { bg: '#EA2D2E', text: '#FFFFFF', abbrev: 'Jv' },
  cpp: { bg: '#00599C', text: '#FFFFFF', abbrev: 'C+' },
});

/** @deprecated use getLangColors — kept for prompt compatibility */
export const LANG_COLORS = Object.freeze({
  JavaScript: { bg: '#F7DF1E', text: '#323330' },
  Python: { bg: '#3776AB', text: '#FFD343' },
  TypeScript: { bg: '#3178C6', text: '#FFFFFF' },
  Java: { bg: '#EA2D2E', text: '#FFFFFF' },
  'C++': { bg: '#00599C', text: '#FFFFFF' },
});

/** @deprecated use getLangAbbrev */
export const LANG_ABBREV = Object.freeze({
  JavaScript: 'JS',
  Python: 'Py',
  TypeScript: 'TS',
  Java: 'Jv',
  'C++': 'C+',
});

export function getLangColors(language) {
  if (language && LANG_COLORS[language]) {
    return LANG_COLORS[language];
  }
  const key = normalizeLanguageIconKey(language);
  const entry = BY_ICON_KEY[key];
  if (entry) return { bg: entry.bg, text: entry.text };
  return { bg: '#232635', text: '#8892A4' };
}

export function getLangAbbrev(language) {
  if (language && LANG_ABBREV[language]) {
    return LANG_ABBREV[language];
  }
  const key = normalizeLanguageIconKey(language);
  if (BY_ICON_KEY[key]) return BY_ICON_KEY[key].abbrev;
  return language?.slice(0, 2) ?? '??';
}
